import { render } from "./course-student-filter.vue?vue&type=template&id=0db52a6e"
import script from "./course-student-filter.vue?vue&type=script&lang=js"
export * from "./course-student-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__